import React from 'react';
import { compose } from 'ramda';

import styleFile from './buttonCalendar.js';
import AvailDatepicker from '../AvailDatepicker/AvailDatepicker';
import AvailDatepickerModal from '../AvailDatepicker/AvailDatepickerModal.jsx';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { RichText, Button } from '@synergycms_core/components/generic/';
import NewAvailButton from '../AvailDatepicker/NewAvailButton.jsx';
import Modal from '@synergycms_core/components/generic/Modal';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider.jsx';

const OpenButton = compose(withThemeJSS({ styleFile, displayName: 'ButtonCalendar', link: true }))(props => {
  const { classes } = props.theme.styles;

  return (
    <Button
      id="td-d1-calendar-subh-00"
      onClick={props.onClick}
      ariaLabel={'_%ver calendario%_'}
      translate={true}
      innerStyle={
        props.theme.deviceType === 'DESK'
          ? ['roboto13Black', 'searchOptionsCalendar']
          : ['roboto13Black', 'searchOptionsCalendarMobile']
      }
      >
      <RichText
        text={'_%ver calendario%_'}
        translate={true}
        ucFirst={true}
        innerStyle={['uppercase', 'mainColor', 'seeCalendarButton']}
        icon={{
          svg: 'calendar',
          innerStyle: [classes.calendarSvg]
        }}
      />
      {props.theme.deviceType === 'DESK' && (
        <RichText
          text={'_%con las mejores ofertas%_'}
          translate={true}
          ucFirst={true}
          innerStyle={['roboto11Gold400']}
        />
      )}
    </Button>
  );
});

const AvailCalendarDatePicker = compose(withThemeJSS({ styleFile, link: true }))(class AvailCalendarDatePicker extends React.Component {
  static displayName = 'ButtonCalendar';
  
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  onRangeChange = (dates) => {
    this.setState(state => ({
      dates: dates
    }));
  };
  
  render() {
    
      return (<div>
        <AvailDatepicker 
        onRangeChange={this.onRangeChange}
        innerStyle={'availDatepickerModal'}
        />
        <NewAvailButton dates={this.state.dates} />
      </div>);
  }
});


const ButtonCalendar = class ButtonCalendar extends React.Component {
  static displayName = 'ButtonCalendar';
  
  constructor(props) {
    super(props);
    this.state = {
      showDatepickerAvail: false, 
      showCalendar : false
    };
  }

  onRangeChange = (dates) => {
    this.setState(state => ({
      dates: dates
    }));
  };

  toogleDatepickerModal = e => {
    e.preventDefault();
    this.setState(state => ({
      showCalendar: !state.showCalendar
    }));
  };
  
  closeModal = () => {
    const toggle = this.props.toggleModal || (this.props.config && this.props.config.toggleModal);
    if (typeof toggle === 'function') toggle(false, 'roomDetailTooltip');
    this.setState(state => ({
      showCalendar: false
    }));
  };

  render() {
    const { theme, webType } = this.props;
    const { classes } = theme.styles;
    return (
      <div
        className={[
          this.props.theme.deviceType === 'DESK'
            ? classes.buttonCalendarContainerDesktop
            : classes.buttonCalendarContainer,
          theme.width < 801 && webType === 'WI'
          ? classes.buttonCalendarWI
          : classes.buttonCalendarPORTAL,
        ].join(' ')}>
        {this.props.theme.deviceType !== 'DESK' ? 
            <>
              <AvailDatepickerModal
                modalTitle={'_%calendario de precios%_'}
                modalText={'_%calendario%_'}
                dates={this.state.dates}
                onRangeChange={this.onRangeChange}
                buttonEvent={this.toogleDatepickerModal}
                closeCallback={this.closeModal}
              />
              { this.state.showCalendar && <NewAvailButton innerStyle={['availDatepickerDateButton']} dates={this.state.dates} onSameDateSelected={this.closeModal} />}
            </>
          :
            <Modal
              innerStyle={'calendarModal'}
              typeModal={'calendarModal'}
              closeButtonStyle={classes.calendarCloseButton}
              popover={(closeModalAction) => <AvailCalendarDatePicker/>}>
              <OpenButton />
            </Modal>
        }
        {theme.width < 801 && webType === 'WI' && (
          <RichText
            text={'_%con las mejores ofertas%_'}
            translate={true}
            ucFirst={true}
            innerStyle={classes.bestSalesMobil}
          />
        )}
      </div>
    );
  }
};

export default compose(showPopover,withThemeJSS({ styleFile, link: true }))(ButtonCalendar);
